import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import ProductList from '../components/Products/ProductList';
import EditProduct from '../components/Products/EditProduct';
// import ViewShipment from '../components/Shipments/ViewShipment';


const Products = () => {
  return (
    <Routes>
      <Route path="/" element={<ProductList />} />
      <Route path="/edit/:id" element={<EditProduct />} />
      <Route path="/edit" element={<EditProduct />} />
      {/* <Route path="/view/:id" element={<ViewShipment />} /> */}
    </Routes>
  )
}

export default Products;